import { render } from "./AlunoDados.vue?vue&type=template&id=44816d91&scoped=true"
import script from "./AlunoDados.vue?vue&type=script&lang=js"
export * from "./AlunoDados.vue?vue&type=script&lang=js"

import "./AlunoDados.vue?vue&type=style&index=0&id=44816d91&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44816d91"]])

export default __exports__